// extracted by mini-css-extract-plugin
export default {"container":"timbrature_container__Cxjil","header":"timbrature_header__2thgQ","buttonContainer":"timbrature_buttonContainer__OUvPF","title":"timbrature_title__68i5Z"};